module.exports = __webpack_public_path__ + "img/4.527a4aac.png";